getWebContext = require './get-web-context'
logTracking = require './log-tracking'

module.exports = (category, verb, dirObj, prepObj, indObj, method, context) ->
  window.sp? 'trackUnstructEvent:cf',
    schema: 'iglu:com.trello/client-event/jsonschema/1-0-0'
    data:
      'ue_category': category
      'ue_verb': verb
      'ue_dir_object': dirObj
      'ue_prep_object': prepObj
      'ue_ind_object': indObj
      'ue_method': method
      'ue_context': context
  , getWebContext()

  logTracking { category, verb, dirObj, prepObj, indObj, method, context }



// WEBPACK FOOTER //
// ./app/scripts/debug/trackUe.coffee